// extracted by mini-css-extract-plugin
export var $animation_name = "SkipLink-module--$animation_name--bbdb5";
export var SkipLink = "SkipLink-module--SkipLink--67bda";